import { render, staticRenderFns } from "./LockAdd.vue?vue&type=template&id=0523e018&scoped=true&"
import script from "./LockAdd.vue?vue&type=script&lang=js&"
export * from "./LockAdd.vue?vue&type=script&lang=js&"
import style0 from "./LockAdd.vue?vue&type=style&index=0&id=0523e018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0523e018",
  null
  
)

export default component.exports